import { gettext } from '@eventbrite/i18n';
import { OrganicEventSearchFiltersApiPayload } from '@eventbrite/search-utils';
import React from 'react';
import TOP_10_CITIES from '../../../../__fixtures__/top10Cities.json';
import { LIGHTHOUSE_ORGANIZERS } from '../../../home/constants/category';
import { CategoryBrowseEvents } from '../../containers/CategoryBrowseEvents';
import { useRouteContext } from '../../context';
import { useLocation } from '../../hooks/queries/location';
import { CATEGORY_BROWSE_PLACEMENT } from '../../utils/analytics';

interface LighthouseCreatorProps {
    adSlots?: Array<number>;
}

export const LighthouseCreator: React.FunctionComponent<
    LighthouseCreatorProps
> = ({ adSlots = [] }) => {
    const { parsedValues, featureFlags, match } = useRouteContext();
    const { data: locationData } = useLocation();
    const activeTag = parsedValues?.activeTag || '';
    const placeId = locationData?.placeId || '';

    const queryOverload: OrganicEventSearchFiltersApiPayload = {
        price: 'paid',
        places: [placeId],
        dates: ['current_future'],
        page_size: 50,
        include_mature_events: true,
        include_manual_events: true,
        aggs: {},
        organizers_or: LIGHTHOUSE_ORGANIZERS[placeId],
        sort: 'date',
        available: true,
        image: true,
        tags: [activeTag],
    };

    if (
        !(
            featureFlags?.enableLighthouseCreatorsCategoryBrowse &&
            match.params.category &&
            placeId in TOP_10_CITIES
        )
    )
        return null;

    return (
        <CategoryBrowseEvents
            queryOverload={queryOverload}
            title={gettext('Fresh finds')}
            adSlots={adSlots}
            bucketName={CATEGORY_BROWSE_PLACEMENT}
            bucketKey="lighthouse_creators_category_browse"
            bucketPosition="3"
            lazyLoadCarouselElements
            includeHyperlinks={false}
        />
    );
};
